import UserModel from '@/models/User';

const GET_ADDRESS_EDIT_DETAIL = 'GET_ADDRESS_EDIT_DETAIL';
const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
const DELETE_ADDRESS = 'DELETE_ADDRESS';

/**
 * 获取收货地址详情
 * @param {number} id 收货地址id
 */
async function getAddressEditDetail(id) {
  const payload = await new UserModel().addressDetail(id);
  return {
    type: GET_ADDRESS_EDIT_DETAIL,
    payload
  }
}

/**
 * 新增/修改收货地址信息
 * @param {Object} params {
 *    @param {number} id 如果是修改收货地址需传入此参数
 * }
 */
async function updateAddress(params) {
  const payload = await new UserModel().updateAddress(params);
  return {
    type: UPDATE_ADDRESS,
    payload
  }
}

/**
 * 删除收货地址
 * @param {number} id 收货地址id
 */
async function deleteAddress(id) {
  const payload = await new UserModel().deleteAddress([id]);
  return {
    type: DELETE_ADDRESS,
    payload
  }
}

const ACTION_TYPES = {
  GET_ADDRESS_EDIT_DETAIL,
  UPDATE_ADDRESS,
  DELETE_ADDRESS,
};

const ACTION = {
  getAddressEditDetail,
  updateAddress,
  deleteAddress,
};

const AddressEdit = {
  ACTION_TYPES,
  ACTION
}

export default AddressEdit;